import { Alert, Text } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function EmptyListMessage() {
	return (
		<Alert
			status="info"
			borderRadius="8px"
			flex="1"
			fontSize="14px"
			height="40px"
			border="1px"
			borderColor="#0D69D4"
		>
			<span>
				{" "}
				<FontAwesomeIcon
					icon={["far", "circle-exclamation"]}
					style={{ color: "#0D69D4" }}
				></FontAwesomeIcon>
			</span>
			<Text as="span" ml="5px">
				There are no items registered yet.
			</Text>
		</Alert>
	);
}
